export const RF_FORM_GROUP = 'rf-form-group';
export const RF_DISABLED = 'rf-disabled';
export const RF_ERROR = 'rf-error';
export const RF_ACTIVE = 'rf-active';
export const RF_WARNING = 'rf-warning';
export const RF_HELPER_TEXT = 'rf-helper-text';

export const RF_REQUIRED = 'rf-required';
export const RF_FILLED = 'rf-filled';
